/* NutraBlast — comportamento da página, adaptado para Shopify.
   Carrinho (AJAX real quando há data-variant-id), marquee do carrossel,
   FAQ de item único aberto, nav mobile e scroll reveal. */
(function () {
  'use strict';

  // O snippet de assets é renderizado por todas as seções, então este script
  // aparece N vezes na página — e <script src> igual executa N vezes.
  // Trava global: só a primeira execução roda.
  if (window.__nutrablastInit) return;
  window.__nutrablastInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- cart */
  var cartCountEl = document.querySelector('[data-cart-count]');

  function bumpCart(count) {
    if (!cartCountEl) return;
    if (typeof count === 'number') cartCountEl.textContent = String(count);
    cartCountEl.classList.remove('is-bumped');
    // Força reflow para reiniciar a animação em cliques rápidos.
    void cartCountEl.offsetWidth;
    cartCountEl.classList.add('is-bumped');
  }

  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cartCountEl) cartCountEl.textContent = String(cart.item_count);
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    if (!(e.target instanceof Element)) return;
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) {
      // Sem variante configurada: apenas o feedback visual do protótipo.
      bumpCart();
      return;
    }

    e.preventDefault();
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add-to-cart failed');
        return r.json();
      })
      .then(function () {
        bumpCart();
        refreshCartCount();
        document.dispatchEvent(new CustomEvent('nb:cart:added', { detail: { variantId: variantId } }));
      })
      .catch(function () {
        window.location.href = '/cart/add?id=' + variantId + '&quantity=1';
      })
      .finally(function () { btn.disabled = false; });
  });

  if (cartCountEl) refreshCartCount();

  /* ----------------------------------------------------------- mobile nav */
  var burger = document.querySelector('.nav__burger');
  var navLinks = document.getElementById('nav-menu');

  function setNav(open) {
    if (!burger || !navLinks) return;
    burger.setAttribute('aria-expanded', String(open));
    navLinks.classList.toggle('is-open', open);
  }

  if (burger && navLinks) {
    burger.addEventListener('click', function () {
      setNav(burger.getAttribute('aria-expanded') !== 'true');
    });
    navLinks.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') setNav(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setNav(false);
    });
    window.matchMedia('(min-width: 901px)').addEventListener('change', function (e) {
      if (e.matches) setNav(false);
    });
  }

  /* ------------------------------------------------------------- carousel */
  // O marquee anima translateX(-50%), então a trilha precisa de duas metades
  // idênticas. Clona os cards autorados; as cópias ficam ocultas para AT.
  document.querySelectorAll('[data-carousel-track]').forEach(function (track) {
    // Guarda extra contra clonagem dupla (ex.: reload de seção no theme editor).
    if (track.dataset.nbCloned) return;
    track.dataset.nbCloned = 'true';

    var items = Array.prototype.slice.call(track.querySelectorAll('[data-carousel-item]'));
    if (!items.length) return;

    function cloneOf(item) {
      var clone = item.cloneNode(true);
      clone.removeAttribute('data-carousel-item');
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('a, button, input').forEach(function (el) {
        el.setAttribute('tabindex', '-1');
      });
      return clone;
    }

    // O loop anima translateX(-50%), então a PRIMEIRA metade da trilha
    // precisa ser mais larga que a viewport — senão sobra um vão no fim.
    // Repete os cards originais até cobrir a tela...
    var baseWidth = track.scrollWidth;
    var repeats = Math.max(0, Math.ceil(window.innerWidth / baseWidth) - 1);
    for (var i = 0; i < repeats; i++) {
      items.forEach(function (item) { track.appendChild(cloneOf(item)); });
    }

    // ...e então duplica a metade inteira para o -50% fechar sem emenda.
    Array.prototype.slice.call(track.children).forEach(function (child) {
      track.appendChild(cloneOf(child));
    });

    // Mantém a velocidade do protótipo (~36px/s) independente da largura.
    var half = track.scrollWidth / 2;
    if (half > 0) track.style.animationDuration = Math.round(half / 36) + 's';
  });

  // Mesma garantia para o marquee da barra de anúncios: o conteúdo (já em
  // 2 metades vindas do Liquid) dobra até a metade cobrir a viewport.
  document.querySelectorAll('.announce__track').forEach(function (tr) {
    if (tr.dataset.nbFilled) return;
    tr.dataset.nbFilled = 'true';
    if (!tr.children.length || !tr.scrollWidth) return;
    var guard = 0;
    while (tr.scrollWidth / 2 < window.innerWidth && guard < 6) {
      Array.prototype.slice.call(tr.children).forEach(function (child) {
        tr.appendChild(child.cloneNode(true));
      });
      guard++;
    }
  });

  /* ------------------------------------------------------------------ faq */
  // Acordeão de item único; o primeiro vem aberto por padrão.
  var faqButtons = document.querySelectorAll('.faq__q');

  faqButtons.forEach(function (btn) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));

    btn.addEventListener('click', function () {
      var willOpen = btn.getAttribute('aria-expanded') !== 'true';

      faqButtons.forEach(function (other) {
        var otherPanel = document.getElementById(other.getAttribute('aria-controls'));
        other.setAttribute('aria-expanded', 'false');
        if (otherPanel) otherPanel.hidden = true;
      });

      btn.setAttribute('aria-expanded', String(willOpen));
      if (panel) panel.hidden = !willOpen;
    });
  });

  /* -------------------------------------------------------- scroll reveal */
  // O que já está nos primeiros 92% da viewport no load fica como está;
  // o resto sobe com fade uma única vez.
  var revealTargets = document.querySelectorAll('[data-reveal]');

  if (!reduceMotion && 'IntersectionObserver' in window && revealTargets.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.12 });

    revealTargets.forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight * 0.92) return;
      el.classList.add('reveal-ready');
      io.observe(el);
    });
  }
})();
